import React, { useState } from "react";
import TableRow from "./content/subscriberDetail/TableRow";
import LoaderModal from "./content/LoaderModal";

import useSWR, { mutate } from "swr";
import { fetcher } from "./../../../services/fetcher";
import { domain } from "./../../../global/domain";
import { useParams } from "react-router-dom";

const GroupCoachingUserDetail = () => {
  const { courseId, userId } = useParams();
  const [loading, setLoading] = useState(false);

  const { data, error } = useSWR(
    `https://${domain}/subscriptions/follow-up/details/${userId}/${courseId}`,
    fetcher
  );

  return (
    <>
      {data && (
        <div className="min-h-screen h-full flex flex-col space-y-6 overflow-y-auto x-sm:px-4 md:px-0">
          <div className="p-8 text-right">
            <p className="md:text-base 2xl:text-2xl">تدريب جماعي</p>
            <h3 className="md:text-2xl 2xl:text-6xl font-extrabold">
              متابعة المشتركين
            </h3>
          </div>
          <div className="bg-white rounded-2xl shadow-2xl x-sm:w-full md:w-11/12 md:mx-8 x-sm:p-2 md:p-4 2xl:p-12 flex flex-col">
            <div className="flex flex-row items-center justify-end space-x-6">
              <h1 className="font-bold x-sm:text-xs md:text-2xl 2xl:text-6xl">
                {`${data.user.family_name} ${data.user.given_name}`}
              </h1>
              <img
                className="rounded-full x-sm:w-14 x-sm:h-14 md:w-20 md:h-20 2xl:w-36 2xl:h-36 picfit"
                alt="logo"
                src={data.user.image}
              />
            </div>
            <div className="flex flex-col x-sm:space-y-4 md:space-y-8 2xl:space-y-12 border-t-2 x-sm:mt-2 md:mt-4 md:pt-4 2xl:mt-8 2xl:pt-8 border-gray-200">
              <div className="flex flex-row space-x-4 justify-between font-bold text-gray-300 x-sm:text-xs md:text-base 2xl:text-4xl">
                <i>التقدم</i>
                <i>الجلسات المنجزة</i>
                <i>فصول المكتملة</i>
                <i>تاريخ الإشتراك</i>
              </div>
              <div className="flex flex-row space-x-4 justify-between font-bold text-reghda-black x-sm:text-xs md:text-base 2xl:text-4xl">
                <i>{data.progress}</i>
                <i className="flex flex-row items-center justify-center space-x-2">
                  <span>جلسات</span>
                  <span>{data.completed_sessions}</span>
                </i>
                <i className="flex flex-row items-center justify-center space-x-2">
                  <span>فصول</span>
                  <span>{data.completed_chapters}</span>
                </i>
                <i>{data.debut_date}</i>
              </div>
            </div>
          </div>
          <div className="x-sm:w-full md:w-11/12 md:mx-8 md:p-4 2xl:p-12 flex x-sm:flex-col x-sm:space-y-6 md:flex-row md:space-x-6">
            <div className="x-sm:w-full md:w-1/2"></div>
            <div className="bg-white rounded-2xl shadow-2xl x-sm:w-full md:w-1/2 x-sm:p-2 md:p-4 2xl:p-12 flex flex-col space-y-3 2xl:space-y-6">
              <div className="flex flex-row items-center justify-center font-bold text-reghda-blue border-b-2 border-reghda-blue pb-2 mb-2 x-sm:text-xs md:text-base 2xl:text-4xl">
                <i className="w-1/3 text-center">الوضعية</i>
                <i className="w-1/3 text-center">الدروس المكتملة</i>
                <i className="w-1/3 text-center">فصول</i>
              </div>
              {data.details.map((item) => (
                <TableRow
                  notClickable={true}
                  data={[
                    item.status,
                    item.completed_modules,
                    item.chapter.title,
                  ]}></TableRow>
              ))}
            </div>
          </div>
          <LoaderModal modalIsOpen={loading}></LoaderModal>
        </div>
      )}
    </>
  );
};

export default GroupCoachingUserDetail;
